import { readRoutineProgression, type RoutineProgression } from './routines';
export interface RoutineReviewContext {
  guided?: boolean; routineId?: string; routineDayIndex?: number; routineName?: string; routineDayName?: string; routineProgression?: RoutineProgression;
}
const key = (owner: string) => 'vyv_routine_review:' + owner;
export function readRoutineReviewContext(value: unknown): RoutineReviewContext {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  const raw = value as Record<string, unknown>, result: RoutineReviewContext = {};
  if (raw.guided === true) result.guided = true;
  if (typeof raw.routineId === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(raw.routineId)
    && Number.isInteger(raw.routineDayIndex) && Number(raw.routineDayIndex) >= 0 && Number(raw.routineDayIndex) < 32) {
    result.routineId = raw.routineId; result.routineDayIndex = Number(raw.routineDayIndex);
  }
  for (const field of ['routineName', 'routineDayName'] as const) if (typeof raw[field] === 'string' && raw[field].trim() && raw[field].length <= 160) result[field] = raw[field];
  if (raw.routineProgression !== undefined) {
    try { result.routineProgression = readRoutineProgression(raw.routineProgression); } catch { /* Invalid optional progression cannot change exercise targets. */ }
  }
  return result;
}
export function savedRoutineReviewContext(ownerId: string): RoutineReviewContext {
  try {
    const saved = JSON.parse(sessionStorage.getItem(key(ownerId)) ?? 'null');
    return saved?.version === 1 && saved.ownerId === ownerId ? readRoutineReviewContext(saved.context) : {};
  } catch { return {}; }
}
export function saveRoutineReviewContext(ownerId: string, context: RoutineReviewContext): void {
  sessionStorage.setItem(key(ownerId), JSON.stringify({ version: 1, ownerId, context: readRoutineReviewContext(context) }));
}
